<template>
    <div id="card">
        <div id="chart">
            <apexchart :type="chartType" height="360" :options="chartOptions" :series="series"></apexchart>
        </div>
    </div>
</template>
<script>
import VueApexCharts from "vue3-apexcharts";
export default {
    props : {
        chartData : {
            type : Array,
            default : []
        },
        chartType : {
          type : String,
          default : 'bar'
        }
    },
    components: {
        apexchart : VueApexCharts,
    },
    data(){ 
        return {
          series: this.chartData.datasets,
          chartOptions: {
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
              toolbar: {
                show: false
              },
              zoom: {
                enabled: true
              }
            },
            responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom',
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }],
            plotOptions: {
              bar: {
                horizontal: false,
              },
            },
            dataLabels: {
              enabled: false
            },
            xaxis: {
              categories: this.chartData.categories
            },
            legend: {
              position: 'bottom',
            },
            fill: {
              opacity: 1
            }
          }
      }
    },
};
</script>